import GetMarketingPlan from './GetMarketingPlan';

export default GetMarketingPlan;
